import { AbstractLocalDataAccessLayer } from "@/lib/utility/data/local-data-access-layer.abstract";
import { IInvoice, Invoice } from "@/models/invoice.entity";

export const InvoiceDataAccessLayer = new (class extends AbstractLocalDataAccessLayer<IInvoice> {
  getIdentifier(entity: IInvoice): string {
    return entity.id;
  }

  protected mapEntity(entity: IInvoice): IInvoice {
    return new Invoice(entity);
  }
})();
